<template>
    <!-- The bell: an icon button in the full menu, a list item in the rail.
         The badge counts the unread notifications, 99+ above 99. -->
    <v-list-item v-if="listitem" v-bind="$attrs">
        <template v-slot:prepend>
            <v-badge color="accent" :model-value="!!count" :content="count" max="99">
                <v-icon>mdi-bell-outline</v-icon>
            </v-badge>
        </template>
        <v-list-item-title>{{ label }}</v-list-item-title>
    </v-list-item>
    <v-btn v-else v-bind="$attrs" icon variant="text" :aria-label="label">
        <v-badge color="accent" :model-value="!!count" :content="count" max="99">
            <v-icon>mdi-bell-outline</v-icon>
        </v-badge>
    </v-btn>
</template>

<script setup>
defineOptions({ inheritAttrs: false })
defineProps({
    listitem: { type: Boolean, default: false },
    count: { type: Number, default: 0 },
    label: { type: String, default: "" },
})
</script>
